// extracted by mini-css-extract-plugin
export default {"tableflow":"TableFlow_tableflow__H-Vi6","small":"TableFlow_small__-TOMX","normal":"TableFlow_normal__Gy3+S","big":"TableFlow_big__QFIOm"};